import { Stack, Grid } from '@mui/material';
import React from 'react';

import EmailTextBorder from '../../../components/EmailTextBorder';
import { Label } from '../../../components/Label';
import WsButton from '../../../components/WsButton/WsButton';
import { FormLabel, ReceiverInput } from '../helper';

type EmailInputProps = {
  name: string;
  nameForReceiverInput: 'to' | 'cc' | 'bcc';
  callbackHandler(): void;
};
const EmailInput = ({ name, nameForReceiverInput, callbackHandler }: EmailInputProps) => {
  return (
    <EmailTextBorder>
      <Stack direction="row" alignItems={'center'}>
        <FormLabel label={name} />
        <ReceiverInput name={nameForReceiverInput} />
        <Grid item xs={3}>
          <Stack spacing={2} direction="row" justifyContent={'flex-end'}>
            <WsButton type="button" variant="text" onClick={() => callbackHandler()}>
              <Label>Close {name}</Label>
            </WsButton>
          </Stack>
        </Grid>
      </Stack>
    </EmailTextBorder>
  );
};
export default EmailInput;
